<template>
  <div>
    <list row-key="DisableVersionId" ref="list" unit="禁用版本" :page="page" :query-params="params"
      :show-checkbox="$permission.canDel()" :show-query="showQuery" :get-data-func="api.list" @reset="$refs.treeSelect.clearHandle()">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="版本名">
          <el-input v-model="params.VersionName" placeholder="请填写版本名" clearable></el-input>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="VersionName" label="版本号" />
        <el-table-column prop="AddTime" label="添加时间" width="150" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  import treeSelect from "@/components/common/treeSelect";

  export default {
    mixins: [listMixin],
    components: { list,treeSelect },
    data() {
      return {
        api: require("@/api/op/disableversion").default,
        dpApi: require("@/api/basic/dp").default,
        params: {
          VersionName: "",
        },
        TreeData: [],
        props: {
          value: "DpId",
          label: "DpName",
          children: "children",
        },
      };
    },
    beforeMount() {
      //this.dpApi.getAuthList({ DpTypes: [2, 3, 4, 5], Status: 3, NoReturnParent: true }).then((res) => {
      //  this.TreeData = this.$commonJs.toTreeData(res.Data, "DpId");
      //});
    },
    methods: {
    onTreeSelect(t) {
      if (!t) {
        this.params.DpIdChain = "";
        this.params.DpId = null;
      } else {
        this.params.DpIdChain = t.IdChain;
        this.params.DpId = t.DpId;
      }
    },
      delRange(ids) {
        this.api.delete({ ids }).then((res) => {
          if (res.Code == 0) {
            this.$message.success("删除成功");
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
        });
      },
    },
  };
</script>